import { Option } from "./Option";

export interface ElementImportViewModel {
    allMissingTaskPackages: string;
    allMissingSubProcesses: string;
    allMissingEnvironmentVariables: string;
    importResults: ElementImportEntry[];
}

export interface ElementImportEntry {
    missingTaskPackages: string[];
    missingSubProcesses: string[];
    missingEnvironmentVariables: string[];
    uri: FrendsElementUri;
    name: string;
    typeName: string;
    localizedTypeName: string;
    maxVersion?: number;
    hasConflict: boolean;
    hasMissingTasks: boolean;
    hasMissingSubprocess: boolean;
    hasMissingEnvironmentVariables: boolean;
    references: FrendsElementUri[];
    isSubProcess: boolean;
    isDeleted: boolean;
}

export interface FrendsElementUri {
    type: string;
    id: string;
    version: number;
}

export interface ImportSettings {
    uri: FrendsElementUri;
    conflictOption: ImportConflictOption;
    conflictOptionsList: Array<Option<ImportConflictOption>>;
}

export enum ImportConflictOption {
    Error = "Error",
    UseExisting = "UseExisting",
    NewVersion = "NewVersion",
    NewActiveElement = "NewActiveElement",
    NewInactiveElement = "NewInactiveElement",
    NewDraft = "NewDraft",
    ExistingDraft = "ExistingDraft"
}
export interface ImportResult {
    successful: boolean;
    message: string;
}
